import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import * as d3 from 'd3';
@Component({
  selector: 'app-subcategory-treemap-chart',
  templateUrl: './subcategory-treemap-chart.component.html'
})
export class SubcategoryTreemapChartComponent implements OnInit {
    @Input() GraphData: any;
  constructor() { }
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    let inputData = this.GraphData;
        d3.select(inputData.chartContainerName).html("");
        d3.select(inputData.chartContainerName).classed('subcategorytreemap', true);
        //document.getElementById(inputData.chartContainerName).innerHTML = '';
        //document.getElementById(inputData.chartContainerName).classList.add("treemap");
        var w = d3.select(inputData.chartContainerName).node().offsetWidth; //document.getElementById(inputData.chartContainerName).offsetWidth;
        var h = 180;
        var margin = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        };
        var containerName = inputData.chartContainerName.split('#')[1];
        var width = w - margin.left - margin.right;
        var height = h - margin.top - margin.bottom;
        var svg = d3.select(inputData.chartContainerName)
            .append('svg')
            .classed("resizableSVG", true)
            .attr('id', 'svg_' + containerName)
            .attr('xmlns', "http://www.w3.org/2000/svg")
            .attr('viewBox', "0 0 " + w + " " + h + "")
            .attr('preserveAspectRatio', 'xMidYMid meet')
            .style('overflow', 'visible')
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');
    
        let format = d3.format(",d");
    
        var treemap = d3.treemap()
            .tile(d3.treemapResquarify)
            .size([width, height])
            .round(true)
            .paddingInner(1);
    
        var root = d3.hierarchy(inputData.chartData)
            .eachBefore(function (d) { return d.data.id }) // = (d.parent ? d.parent.data.id + "." : "") + d.data.id; })
            .sum(this.sumBySize)
            .sort(function (a, b) {
                return b.height - a.height || b.value - a.value;
            });
        treemap(root);
        var cell = svg.selectAll("g")
            .data(root.leaves())
            .enter().append("g")
            .attr("transform", function (d) { return "translate(" + d.x0 + "," + d.y0 + ")"; });
    
        cell.append("rect")
            .attr("id", function (d, i) { return containerName + "_tree" + i })
            .attr("width", function (d) { return d.x1 - d.x0; })
            .attr("height", function (d) { return d.y1 - d.y0; })
            .attr("fill", function (d, i) { return inputData.colorCodes[i % inputData.colorCodes.length]; })
            .style('opacity', '1')
            .attr('stroke', '#ffffff')
            .attr('stroke-width', '0.5px')
            .on('mouseover', (d, i) => {
                var node = d3.select(inputData.chartContainerName + "_tree" + i);
                node.style('cursor', 'pointer')
                node.style('opacity', '0.8')
                node.attr('stroke', '#999999')
                var tooltip = d3.select(node.node().closest('svg'))
                    .select('g')
                    .append("g")
                    .style("cursor", "pointer")
                    .attr("class", "tooltip")
                    .style("opacity", 1)
                tooltip.append("rect")
                    .attr("width", 90)
                    .attr('height', 50)
                    .style('fill', '#FFFFFF')
                    .style('pointer-events', 'none')
                    .style('stroke', node.style('fill'))
                    .style('stroke-width', 2)
                    .style('fill-opacity', 0.9);
                var textSvg = tooltip.append("text")
                    .attr('x', 8)
                    .attr('y', 15)
                    .style('pointer-events', 'none')
                    .style('font-weight', 'bold')
                    .style('fill', '#333333')
                    .style('font-size', '12px')
                    .style('font-family', 'Arial')
                    .style('color', '#333333');
                //textSvg.append("tspan")
                //    .style('font-size', '12px')
                //    .style('pointer-events', 'none')
                //    .style('font-weight', 'bold')
                //    .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
                //    .text(d.parent ? d.parent.data.id : "")
                textSvg.append("tspan")
                    .attr('x', 8)
                    .attr('dy', 15)
                    .style('font-size', '12px')
                    .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
                    .style('pointer-events', 'none')
                    .style('font-weight', 'bold')
                    //.style('fill', d3.select(this).style('fill'))
                    .text(d.data.id + " : " + d.data.value) //&#9679; //&bull;
                //textSvg.append("tspan")
                //    .attr('x', 8)
                //    .attr('dy', 15)
                //    .style('pointer-events', 'none')
                //    .style('font-size', '12px')
                //    .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
                //    .text(d.data.value)
                //    .style('font-weight', 'bold')
            })
            // .on("mousemove", function (d, i) {
            //     var node = d3.select(inputData.chartContainerName + "_tree" + i);
            //     node.style('cursor', 'pointer');
            //     var text = d3.select(node.node().closest('g')).select('text');
            //     //var mousePosition = d3.mouse(this);
            //     var x = d.x1 //d3.event.pageX//mousePosition[0] + width / 2;
            //     var y = d.y1 //d3.event.pageY//mousePosition[1] + height / 2;
            //     //var x = text.node().getAttribute('x')//mousePosition[0];// + width / 2;
            //     //var y = text.node().getAttribute('y')//mousePosition[1];// + height / 2;
            //     var text = d3.select(node.node().closest('svg')).select('g').select('.tooltip text');
            //     //svg.selectAll('.tooltip text tspan').nodes().forEach(element => {
            //     //    console.log(element.getBBox().width);
            //     //})
            //     var bbox = text.node().getBBox();
            //     d3.select(node.node().closest('svg'))
            //         .select('g')
            //         .select('.tooltip rect')
            //         .attr("width", bbox.width + 15)
            //     if (x - bbox.width / 2 < 0) {
            //         x = bbox.width / 2;
            //     }
            //     else if (width - x - bbox.width / 2 < 0) {
            //         x = width - bbox.width / 2;
            //     }
            //     if (y - bbox.height / 2 < 0) {
            //         y = bbox.height * 2;
            //     }
            //     else if (height - y - bbox.height / 2 < 0) {
            //         y = height - bbox.height / 2;
            //     }
            //     d3.select(node.node().closest('svg'))
            //         .select('g')
            //         .select('.tooltip')
            //         .style("opacity", 1)
            //         .attr('transform', `translate(${parseInt(x) - (bbox.width)}, ${parseInt(y) - (bbox.height) + 10})`);
            // })
            .on("mouseout", function (d, i) {
                var node = d3.select(inputData.chartContainerName + "_tree" + i);
                node.attr('stroke', '#ffffff')
                //d3.select(node.node().closest('svg'))
                //    .select('g')
                //    .selectAll('rect')
                //    .style("fill", function (d) { return colorScale(this.dataset.data); })
                d3.select(node.node().closest('svg'))
                    .select('g')
                    .select('.tooltip').style('display', 'none');
                d3.select(node.node().closest('svg'))
                    .select('g')
                    .select(".tooltip").remove();
                d3.select(inputData.chartContainerName).selectAll('rect')
                    .style("opacity", '1');
            })
            .on('click', (d, i) => {
                //LoadSignificantChartsForSubCategory(d);
            });
    
        //cell.append("clipPath")
        //    .attr("id", function (d) { return "clip-" + d.data.id; })
        //    .append("use")
        //    .attr("xlink:href", function (d) { return "#" + d.data.id; });
        //.attr("clip-path", function (d) { return "url(#clip-" + d.data.id + ")"; })
        var text = cell.append("text")
            .attr("class", "textlabel")
            .attr("x", (d, i) => (d.x1 - d.x0) / 2)
            .attr("y", (d, i) => (d.y1 - d.y0) / 2)
            .attr('text-anchor', 'middle')
            .style('font-size', '12px')
            .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
            .attr("pointer-events", "none")
            .style('font-weight', 'normal')
            .style('color', '#000000')
            .style('fill', '#000000')
            .text((d, i) => this.textValue(d));
        //.each(wordWrap)
        //text.append("tspan")
        //    .attr("x", (d, i) => (d.x1 - d.x0) / 2)
        //    .attr("y", (d, i) => (d.y1 - d.y0) / 2)
        //    //.attr("dy", ".35em")
        //    .attr("text-anchor", "middle")
        //    .attr('stroke', '#FFFFFF')
        //    .attr('fill', '#FFFFFF')
        //    .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
        //    .style('font-weight', 'bold')
        //    .attr('stroke-width', '2px')
        //    .attr('stroke-linejoin', 'round')
        //    .text(d => textValue(d))
        //text.append("tspan")
        //    .attr("x", (d, i) => (d.x1 - d.x0) / 2)
        //    .attr("y", (d, i) => (d.y1 - d.y0) / 2)
        //    //.attr("dy", ".35em")
        //    .attr("text-anchor", "middle")
        //    .style('font-family', '"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif')
        //    .style('font-weight', 'bold')
        //    //.style('pointer-events', 'none')
        //    //.style('fill', d3.select(this).style('fill'))
        //    .text(d => textValue(d));
    
        //cell.append("title")
        //    .text(function (d) { return d.data.id + "\n" + format(d.value == 5.99999 ? 0 : d.value); });
  }
  sumBySize(d) {
    return d.value == 0 ? 5.99999 : d.value;
}
textValue(d) {
    var limit = d.x1 - d.x0;
    var label = d.data.id;
    if (d.y1 - d.y0 < 10)
        return;
    switch (true) {
        case limit < 10: return;
            break;
        case limit < 20: return;
            break;
        case limit < 30: return;
            break;
        case limit < 40: limit = 2;
            break;
        case limit < 50: limit = 3;
            break;
        case limit < 60: limit = 4;
            break;
        case limit < 70: limit = 5;
            break;
        case limit < 80: limit = 6;
            break;
        case limit < 90: limit = 7;
            break;
        case limit < 100: limit = 8;
            break;
        case limit < 110: limit = 9;
            break;
        default: limit = 10;
            break;
    }
    //if (limit == 0)
    //    return "";
    if (d.data.id.length > limit) {
        label = d.data.id.substring(0, limit) + '...';
    }
    return label;
}
}
